<template>

      <!-- swiper -->
      <swiper :options="swiperOption" ref="mySwiper" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" onmouseover="swiper.autoplay.stop();" onmouseleave="swiper.autoplay.start();">

          <swiper-slide v-for="(item, index) in candleSticks">
            <statistics-card-line
              icon-right
              toLocaleStr
              v-if="candleSticksArea.analyticsData"
              :icon="isFontExist(index) ? iconPackSymbol(index).icon : index"
              :cryptoFont="isFontExist(index)"
              :cryptoLogo="!isFontExist(index)"
              :statistic="item.fee.toLocaleString('en-US') +' '+$t('toman')"
              :statisticTitle="localeNameSymbol(index)[islocale]"
              :chartData="getSeries(item.data,index)"
              :color="colorSymbol(index)"
              :height="height"
              type="area" />
          </swiper-slide>


          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'

export default{
  props:['candleSticks'],
  components: {
    swiper,
    swiperSlide,
    StatisticsCardLine
  },
  data () {
    return {
      height: 150,
      candleSticksArea: {
        analyticsData: {
          subscribers: 92600
        }
      },
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},

      swiperOption: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 30,
        paginationClickable: true,

        //freeMode: true,
        //freeModeSticky: false,
        //loop: true,


        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        /*
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },
         */
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      }
    }
  },
  methods: {
    getSeries(data,symbol){
      return  [
        {
          name: symbol,
          data: data
        }
      ];
    },
    autoPlay () {
      alert()
    },
    toSlide (i) {
      this.$refs.mySwiper.swiper.slideTo(i, 0)
    }
  },
  created () {
    //this.swiperOption.autoplay = false;

  }
}
</script>
<style lang="scss" scoped>
  @media only screen and (max-width: 768px) {
    .swiper-button-next, .swiper-button-prev{
      height: 25px;
      top: 55%;
    }
  }
  .swiper-container {
    .swiper-button-next, .swiper-button-prev{
      opacity: 0.5;
    }
    .swiper-button-next:hover, .swiper-button-prev:hover{
      opacity: 1;
    }
  }


</style>

